import { z } from 'zod';
// =============================================================================
// BASE SCHEMAS
// =============================================================================
export const ExtensionLocaleSchema = z.enum(['en', 'fr', 'es', 'it', 'de']);
export const ExtensionI18nStringSchema = z
    .object({
    en: z.string(),
    fr: z.string(),
    es: z.string(),
    it: z.string(),
    de: z.string(),
})
    .partial()
    .strict()
    .refine((value) => Object.values(value).some((v) => typeof v === 'string' && v.length > 0), {
    message: 'Must have at least one non-empty locale string',
});
export const ExtensionContextSchema = z.enum(['below-shipping', 'global', 'fulfillment-constraint']);
export const EventTriggerSchema = z.enum([
    'on-order-creation',
    'on-discount-application',
    'on-checkout-initiation',
]);
// =============================================================================
// BRANDED TYPES SCHEMAS
// =============================================================================
export const ExtensionRuleIdSchema = z.string().brand('RuleId');
export const ExtensionIdSchema = z.string().brand('ExtensionId');
export const ExtensionFieldIdSchema = z.string().brand('FieldId');
export const ExtensionActionIdSchema = z.string().brand('ActionId');
// =============================================================================
// EXTENSION SCHEMA
// =============================================================================
// Basic extension schema without circular dependencies
export const BaseExtensionSchema = z
    .object({
    id: ExtensionIdSchema,
    title: ExtensionI18nStringSchema.refine((value) => Object.values(value).some((v) => typeof v === 'string' && v.length > 0), { message: 'Title must have at least one non-empty locale' }),
    description: ExtensionI18nStringSchema.optional(),
    defaultLocale: ExtensionLocaleSchema,
    context: ExtensionContextSchema,
    // Note: actions, fields, and when will be added in the complete schema
})
    .strict();
//# sourceMappingURL=extension.js.map